import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import BackAndBreadCrmOneParent from "./BackAndBreadCumOneParent";
import axios from "axios";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import LoaderRounded from "./LoaderRounded";
import Moment from "react-moment";
import LoaderRoundedWithText from "./LoaderRoundedWithText";
import { Edit } from "@material-ui/icons";
Moment.globalFormat = "D MMM YYYY HH:MM:ss";

const TransactionListAll = () => {
  const [payments, setPayments] = useState([]);

  const [page, setPage] = useState(1);
  const [documentsPerPage, setDocumentsPerPage] = useState(100);
  const [allcount, setAllcount] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [mobileSearch, setMobileSearch] = useState("");

  const [startDateInput, setStartDateInput] = useState("");
  const [endDateInput, setEndDateInput] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [filterdata, setFilterData] = useState([]);
  const [candidate, setCandidate] = useState([]);
  const [loading, setloading] = useState(true);
  const [loader, setLoader] = useState(false);


  const handlePageChange = (selectedItem) => {
    setPage(selectedItem.selected + 1);
  };

  useEffect(() => {
    if (mobileSearch === "") {
      getallData();
    }

    if (mobileSearch.length === 10) {
      getallData();
    }

    setTimeout(() => setloading(false), 1000);
  }, [page, startDate, endDate, mobileSearch]);

  const getallData = () => {
    setLoader(true);

    const data = {
      startdate: startDate ? startDate : "",
      enddate: endDate ? endDate : "",
      documentsPerPage: documentsPerPage,
      page: page,
      mobile: mobileSearch ? mobileSearch : ""
    };

    axios.post(process.env.REACT_APP_APIURL + "/pay/allpaymentPGN", data)
      .then((res) => {
        if (res.data.success) {

          setPayments(res.data.data);
          setFilterData(res.data.data);
          setCandidate(res.data.data);
          setAllcount(res.data.count);
          setNoOfPages(res.data.noOfPages);
          setPage(res.data.currentPage);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };


  const handleClearSearch = () => {
    setMobileSearch("");
    setStartDateInput("");
    setEndDateInput("");
    setStartDate("");
    setEndDate("");
    setPage(1);
  };

  const handleDateSubmit = () => {
    setPage(1);
    setStartDate(startDateInput);
    setEndDate(endDateInput);
  };


  return (
    <div className="payments">
      {loading ? (
        <LoaderRoundedWithText />
      ) : (
        <div>
          <Sidebar />
          <div className="main">
            <div className="topbar mb-3">
              <Navbar title="Razorpay Transaction List" />
            </div>

            <BackAndBreadCrmOneParent
              backLink="dashboard"
              currentTabName="Trasaction List"
            />

            <Row className="mx-3 my-4 justify-content-between">
              <Col md={8}>
                <Row md={12}>
                  <Col md={4}>
                    From:
                    <Form.Control
                      value={startDateInput}
                      onChange={(e) => setStartDateInput(e.target.value)}
                      type="date"
                    />
                  </Col>

                  <Col md={4}>
                    To:
                    <Form.Control
                      value={endDateInput}
                      onChange={(e) => setEndDateInput(e.target.value)}
                      type="date"
                    />
                  </Col>

                  <Col md={2} className="d-flex align-items-center mt-4">
                    <Button
                      disabled={(startDateInput && endDateInput) ? false : true}
                      onClick={handleDateSubmit}
                      className="secondaryBtn"
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Col>

              <Col md={3} className="mt-4 d-flex">
                <Form.Control
                  name="filterListByMobile"
                  placeholder="Search By Mobile"
                  type="text"
                  value={mobileSearch}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setMobileSearch(value);
                    setPage(1);
                  }}
                />

                <Button
                  className="ms-2"
                  variant="success"
                  onClick={() => handleClearSearch()}
                >
                  Clear
                  {/* <Icon.ArrowClockwise /> */}
                </Button>
              </Col>

            </Row>

            <div className="container text-center">
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive-sm" style={{ height: '80vh', overflow: 'auto' }}>
                    <table className="table table-bordered table-responsive" >
                      <thead>
                        <tr className="text-center">
                          <th>No</th>
                          <th>Event Name</th>
                          <th>Mobile</th>
                          {/* <th>Email</th> */}
                          <th>Status</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loader ? (
                          <tr key={loader}>
                            <td colSpan={7}>
                              <LoaderRounded />
                            </td>
                          </tr>
                        ) :
                          payments.length > 0 ?
                            payments?.map((item, i) => {
                              return (
                                <tr key={item.id}>
                                  <td>{(page - 1) * documentsPerPage + (i + 1)}</td>
                                  {/* <td>{page_selected * limit + i + 1}</td> */}
                                  <td>{item.description}</td>
                                  <td>{item.contact}</td>
                                  <td>
                                    {item.status === "captured" ? (
                                      <span className="text-center text-success">
                                        {item.status}
                                      </span>
                                    ) : (
                                      <span className="text-center text-danger">
                                        {item.status}
                                      </span>
                                    )}
                                  </td>
                                  <td>{item.amount / 100}</td>
                                  <td>
                                    <Moment unix>{item.created_at}</Moment>
                                  </td>
                                  <td className="icanostyle text-center">
                                    <Link
                                      to={{
                                        pathname: "/checkTransactionStatus",
                                        data: item,
                                      }}
                                    >
                                      <button className="btn btn-outline-info btn-sm me-2">
                                        <Edit />
                                      </button>
                                    </Link>
                                  </td>
                                </tr>
                              );
                            }) :
                            (
                              <tr><td colSpan="6" className="text-center">No Data Found....</td></tr>
                            )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3 me-4 flex-wrap">
                  <div>
                    <ReactPaginate
                      nextLabel="Next"
                      previousLabel="Previous"
                      pageCount={Math.ceil(allcount / documentsPerPage)}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      containerClassName="pagination"
                      activeClassName="btn btn-primary"
                      pageClassName="btn"
                      previousClassName="btn"
                      nextClassName="btn"
                      onPageChange={handlePageChange}
                    />
                  </div>
                  <div
                    className="text-end me-5"
                    style={{
                      whiteSpace: "nowrap",
                      marginLeft: "10px"
                    }}
                  >
                    <strong>Total Records:</strong> {allcount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionListAll;
